(function () {
    var STYLE_ID = 'casper-dev-ghost-ui-dark';

    var SEARCH_DARK_CSS = [
        ':root { color-scheme: dark; }',
        'html, body {',
        '  background: #151719 !important;',
        '  color: rgba(255, 255, 255, 0.9) !important;',
        '}',
        'input, textarea, select {',
        '  background: #1e2124 !important;',
        '  color: #fff !important;',
        '  border-color: #3a3f44 !important;',
        '}',
        'a { color: #6cb6ff !important; }',
        '.bg-white, [class*="bg-white"] { background-color: #1a1d21 !important; }',
        '.bg-gray-50, [class*="bg-gray-50"] { background-color: #1e2124 !important; }',
        '.hover\\:bg-gray-50:hover { background-color: #252a30 !important; }',
        '.text-black, .text-gray-900, [class*="text-gray-900"] { color: rgba(255, 255, 255, 0.9) !important; }',
        '.text-gray-500, .text-gray-600, [class*="text-gray-5"], [class*="text-gray-6"] { color: rgba(255, 255, 255, 0.55) !important; }',
        '.border-gray-100, .border-gray-200, [class*="border-gray"] { border-color: #333 !important; }',
        'button, [role="button"] { color: inherit; }',
        'svg { color: currentColor; }',
        '[class*="shadow"] { box-shadow: 0 8px 30px rgba(0, 0, 0, 0.45) !important; }'
    ].join('\n');

    var PORTAL_DARK_CSS = [
        ':root { color-scheme: dark; }',
        'body, .gh-portal-root { background: #151719 !important; color: rgba(255, 255, 255, 0.9) !important; }',
        '.gh-portal-preview, .gh-portal-popup, .gh-portal-content {',
        '  background: #1a1d21 !important;',
        '  color: rgba(255, 255, 255, 0.9) !important;',
        '}',
        'input, .gh-portal-input, textarea {',
        '  background: #1e2124 !important;',
        '  color: #fff !important;',
        '  border-color: #3a3f44 !important;',
        '}',
        '.gh-portal-closeicon, .gh-portal-header { color: rgba(255, 255, 255, 0.9) !important; }',
        'a { color: #6cb6ff !important; }',
        '.gh-portal-text { color: rgba(255, 255, 255, 0.75) !important; }'
    ].join('\n');

    function isDark() {
        var html = document.documentElement;

        if (html.classList.contains('dark-mode')) {
            return true;
        }

        if (html.classList.contains('auto-color')) {
            return window.matchMedia('(prefers-color-scheme: dark)').matches;
        }

        return false;
    }

    function injectStyles(doc, css) {
        if (!doc || !doc.head) {
            return;
        }

        var existing = doc.getElementById(STYLE_ID);

        if (!isDark()) {
            if (existing) {
                existing.remove();
            }
            return;
        }

        if (existing) {
            return;
        }

        var style = doc.createElement('style');
        style.id = STYLE_ID;
        style.textContent = css;
        doc.head.appendChild(style);
    }

    function injectIframe(iframe, css) {
        if (!iframe) {
            return;
        }

        function tryInject() {
            try {
                var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
                if (doc && doc.head) {
                    injectStyles(doc, css);
                }
            } catch (err) {
                /* cross-origin guard */
            }
        }

        tryInject();
        iframe.addEventListener('load', tryInject);
    }

    function scanGhostUI() {
        var searchRoot = document.getElementById('sodo-search-root');

        if (searchRoot) {
            searchRoot.querySelectorAll('iframe').forEach(function (iframe) {
                injectIframe(iframe, SEARCH_DARK_CSS);
            });
        }

        var portalRoot = document.getElementById('ghost-portal-root');

        if (portalRoot) {
            portalRoot.querySelectorAll('iframe').forEach(function (iframe) {
                injectIframe(iframe, PORTAL_DARK_CSS);
            });
        }
    }

    function removeInjectedStyles() {
        ['sodo-search-root', 'ghost-portal-root'].forEach(function (id) {
            var root = document.getElementById(id);

            if (!root) {
                return;
            }

            root.querySelectorAll('iframe').forEach(function (iframe) {
                try {
                    var doc = iframe.contentDocument;

                    if (doc) {
                        var style = doc.getElementById(STYLE_ID);

                        if (style) {
                            style.remove();
                        }
                    }
                } catch (err) {
                    /* ignore */
                }
            });
        });
    }

    function update() {
        if (isDark()) {
            scanGhostUI();
        } else {
            removeInjectedStyles();
        }
    }

    var rootObserver = new MutationObserver(update);
    rootObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class', 'data-theme']
    });

    var domObserver = new MutationObserver(update);
    domObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    document.addEventListener('casper-dev-theme-change', update);
    document.addEventListener('click', function (event) {
        if (event.target.closest('[data-ghost-search]')) {
            window.setTimeout(update, 50);
            window.setTimeout(update, 250);
            window.setTimeout(update, 800);
        }
    });

    window.setInterval(update, 1000);
    update();
})();
